import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { removeActiveGame } from '../store/GamesSlice'; 
import { DataPacket_Kind } from 'livekit-client';
import MediaContainer from '../../MediaPlayback/components/MediaDisplay/MediaContainer/MediaContainer';
import TicTacToe from './TicTacToe/TicTacToe';
import { setZoomedMediaId } from '../../MediaPlayback/store/livekitSlice/livekitSlice';
import './GameManager.css';
import Survey from './Survey/Survey';
import { useTranslation } from 'react-i18next';
export default function GameManager({ gameData, room }) {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const { zoomedTrackId } = useSelector((state) => state.livekit);
    const [rerenderTrigger, setRerenderTrigger] = useState(true);
    const [floatingVideo, setFloatingVideo] = useState(false);

    const isZoomed = zoomedTrackId === gameData.gameId;
    const { 
        gameId,
        type, 
        player1Name, 
        player2Name, 
        player1Id, 
        player2Id, 
        isSpectator,
        ownerName
    } = gameData;
  
    const gameNameMap = {
        TICTACTOE: t("tic_tac_toe"),
        SURVEY: t("survey")
      };
    const handleUnzoom = (e) => {
        e.stopPropagation();
        dispatch(setZoomedMediaId(null)); 
    };

    const handleCloseGame = async (e) => {
      e.stopPropagation();
      
      if (!isSpectator) {
          const encoder = new TextEncoder();
          const data = encoder.encode(JSON.stringify({ type: 'GAME_CLOSE', gameId }));
          try {
              await room.localParticipant.publishData(data, {
                  reliability: DataPacket_Kind.RELIABLE,
                  destinationIdentities: [] 
              });
          } catch (error) { console.error(error); }
      }
      dispatch(removeActiveGame(gameId));
    };

    const getHeaderTitle = () => {
        if (type === 'TICTACTOE') {
            return isSpectator 
                ? t("spectate_game", {
                    user1: player1Name,
                    user2: player2Name
                  })
                : `Vs ${player1Id === room.localParticipant.identity ? player2Name : player1Name}`;
        }
        if (type === 'SURVEY') {
            const owner = ownerName ?? t("anonymous");
            return t("survey_of", {
                user: owner
              });
        }
        return t("game_in_progress");
    };

    const getGameIcon = () => {
        if (type === 'SURVEY') return 'poll'; 
        return 'sports_esports';
    };
  
    return (
      <MediaContainer
          mediaId={gameId}
          canZoom={true}          
          canFullscreen={false}
          canFloat={floatingVideo}
          autoZoom={type === 'TICTACTOE'}
          containerType="video"
          className={`camera-off ${rerenderTrigger ? 'rerender-trigger' : ''}`}
      >
          {/* === VUE 1 : UNZOOMED (Badge) === */}
          <div 
              className="game-badge-view"
              style={{ 
                  display: isZoomed ? 'none' : 'flex'
                }}
          >
              <div className='game-icon' >
                {type == 'SURVEY' ? 
                   <span className="material-symbols-outlined">
                      poll
                   </span> 
                   : 
                   <span className='tic-tac-toe-icon'></span>
                }
              </div>
              <span className="game-name text-gray-800 font-medium"> 
                {gameNameMap[type] ?? type}
            </span>
          </div>
  
          {/* === VUE 2 : ZOOMED (Jeu au Centre) === */}
          <div 
              className="game-active-view"
              onClick={(e) => e.stopPropagation()}
              style={{ 
                  display: isZoomed ? 'flex' : 'none', 
              }}
          >
              {/* HEADER DU JEU */}
              <div className="game-header">
                  <span className='player-name'>
                     {getHeaderTitle()}
                  </span>
                  
                  {/* GROUPE DE BOUTONS (Droite) */}
                  <div style={{ display: 'flex', gap: '0.5rem' }}>
                      
                      {/* BOUTON 1 : RÉDUIRE (Nouveau) */}
                      <button 
                          onClick={handleUnzoom}
                          title="Réduire"
                          className='unzoom-button'
                      >
                          <span className="material-symbols-outlined" style={{fontSize: '1.125rem'}}>
                              close_fullscreen
                          </span>
                          <span className='hide-in-mobile'>{t("reduce")}</span>
                      </button>

                      {/* BOUTON 2 : ARRÊTER (Existant) */}
                     {!isSpectator && (
                         <button 
                          onClick={handleCloseGame}
                          title="Arrêter la partie"
                          className='close-game-button'
                         >
                          <span className="material-symbols-outlined" style={{fontSize: '1.125rem'}}>
                              cancel
                          </span>
                          <span className='hide-in-mobile'>{t("stop")}</span>
                      </button>
                    )}
                  </div>
              </div>
  
              {/* PLATEAU DE JEU */}
              <div className="game-board">
                  {type === 'TICTACTOE' && (
                      <TicTacToe 
                          room={room}
                          gameId={gameId}
                          player1Id={player1Id}
                          player2Id={player2Id}
                          player1Name={player1Name}
                          player2Name={player2Name}
                          isSpectator={isSpectator}
                      />
                  )}
                  {type === 'SURVEY' && (
                      <Survey
                          room={room}
                          gameId={gameId}
                          gameData={gameData} 
                          isOwner={!isSpectator} 
                      />
                  )}
              </div>
          </div>
  
      </MediaContainer>
    );
}